
























































import { Component, Vue } from 'vue-property-decorator'
import { AnnouncementDto } from '@/models/dtos/announcementDto'
import { UserAdminService as _userAdminService } from '@/admin/services/userAdmin.service'
import { AnnouncementAdminService as _announcementAdminService } from '@/admin/services/announcementAdmin.service'
import { PaginationDto } from '@/models/dtos/paginationDto'
import router from '@/router'
import { mixins } from 'vue-class-component'
import { TemplateMixin } from '@/mixins/templateMixin'
import moment from 'moment'
import { UserDto } from '@/models/dtos/userDto'
import { UserMixin } from '@/mixins/userMixin'
import { PagedResponseDto } from '@/models/dtos/pagedResponseDto'

@Component
export default class AdminAnnouncementList extends mixins(TemplateMixin, UserMixin) {
  // Data
  private users: UserDto[] | null = null
  private announcements: PagedResponseDto<AnnouncementDto> | null = null
  private announcementsPagination: PaginationDto = { pageNumber: 1, pageSize: 15 }

  private announcementsItems: {
    id: string;
    message: string;
    created: string;
    createdBy: string;
  }[] = []

  private announcementsFields = [
    { key: 'message', label: 'Wiadomość', class: 'align-middle' },
    { key: 'created', label: 'Data', class: 'align-middle' },
    { key: 'createdBy', label: 'stworzono przez', class: 'align-middle' },
    { key: 'actions', label: 'Akcje', class: 'align-middle' }
  ]

  // Methods
  private async initAnnouncements() {
    this.announcements = await _announcementAdminService.getAll(this.announcementsPagination.pageNumber, this.announcementsPagination.pageSize)

    this.announcementsItems = []
    for (const announcement of this.announcements.items) {
      const user = this.getUser(this.users!, announcement.createdById)

      this.announcementsItems.push({
        id: announcement.id,
        message: announcement.message,
        created: moment(announcement.created).format('llll'),
        createdBy: `${user?.firstName} ${user?.lastName}`
      })
    }
  }

  private async removeAnnouncements(id: string) {
    let confirm = false
    try {
      confirm = await this.$bvModal.msgBoxConfirm('Czy na pewno chcesz usunąć?', {
        title: 'Potwierdzenie',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'Usuń',
        cancelTitle: 'Anuluj',
        hideHeaderCancel: false,
        headerClass: 'p-2 border-bottom-0',
        footerClass: 'p-2 border-top-0',
        centered: true
      })
    } catch (e) {}

    if (confirm) {
      await _announcementAdminService.remove(id)
      this.initAnnouncements()
    }
  }

  private editAnnouncements(id: string) {
    router.push({ name: 'AdminAnnouncementEdit', params: { id } })
  }

  // Getters
  private get isLoaded(): boolean {
    return !this.announcements || !this.users
  }

  // Lifecycle
  async created() {
    this.users = await _userAdminService.getAll()
    this.initAnnouncements()
  }
}
